// src/comps/eventspage.jsx
import React from "react";
import { Navbar } from "../App";
import eventsImage from "../assets/events.jpg";
import eventsImage1 from "../assets/tarik.jpg";

export default function EventsPage() {
  const events = [
    {
      title: "BUET'88 2025 Annual Reunion Gala Night",
      date: "Saturday, December 27, 2025",
      time: "6:00 PM - 11:59 PM",
      venue: "Hotel Lakeshore Grand",
      description: "Please join us for an unforgettable evening of laughter, friendship, and nostalgia as Batch'88 gathers once again for our 2025 Annual Reunion Gala Night.",
      highlights: [
        "Meet and Greet",
        "Dinner, drinks, and music",
        "Walking down the memory lane"
      ],
      registrationUrl: "https://docs.google.com/spreadsheets/d/10Q0UVitKoiE1ePx_9VkffxB8JJCaQnnz8Pay0AwEWfg/edit?usp=drivesdk",
      imagePath: eventsImage
    },
    {
      title: "BUET'88 2026 Annual Reunion ",
      date: "Friday, Jul 10 2026 to Jule 12, 2026",
      venue: "Hotel Lakeshore Grand",
      description: "Please join us for an unforgettable evening of laughter, friendship, and nostalgia as Batch'88 gathers once again for our 2025 Annual Reunion Gala Night.",
      highlights: [
        "Meet and Greet",
        "Dinner, drinks, and music",
        "Walking down the memory lane"
      ],
      registrationUrl: "https://docs.google.com/spreadsheets/d/15yKAWEAxJ_SNMdGp1Oji-WOgKQ-1IvzbmcZPZaLZswY/edit?usp=sharing",
      imagePath: eventsImage1
    }

  ];

  return (
    <div className="bg-white min-h-screen w-screen">
      <Navbar />
      <div className="container mx-auto px-4 py-12">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-black text-5xl font-bold mb-4">Events</h1>
          <p className="text-black text-lg max-w-3xl mx-auto">
            Join us for memorable gatherings and community activities.
          </p>
        </div>

        {/* Events List */}
        <div className="max-w-5xl mx-auto space-y-12">
          {events.map((event, index) => (
            <EventCard key={index} event={event} />
          ))}
        </div>
      </div>
    </div>
  );
}

const EventCard = ({ event }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200 hover:shadow-2xl transition-shadow duration-300">
      <div className="flex flex-col lg:flex-row">
        {/* Event Image */}
        <div className="lg:w-2/5">
          <img
            src={event.imagePath}
            alt={event.title}
            className="w-full h-64 lg:h-full object-cover"
          />
        </div>

        {/* Event Details */}
        <div className="lg:w-3/5 p-8 space-y-6">
          <h2 className="text-black text-3xl font-bold">{event.title}</h2>

          {/* Date, Time, Venue */}
          <div className="space-y-2">
            <div className="flex items-center gap-3">
              <svg className="w-5 h-5 text-[#800000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span className="text-black font-semibold">{event.date}</span>
            </div>
            <div className="flex items-center gap-3">
              <svg className="w-5 h-5 text-[#800000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-black font-semibold">{event.time}</span>
            </div>
            <div className="flex items-center gap-3">
              <svg className="w-5 h-5 text-[#800000]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span className="text-black font-semibold">{event.venue}</span>
            </div>
          </div>

          {/* Description */}
          <p className="text-black text-base leading-relaxed">
            {event.description}
          </p>

          {/* Program Highlights */}
          {event.highlights && event.highlights.length > 0 && (
            <div>
              <h3 className="text-black text-xl font-bold mb-3">Program Highlights:</h3>
              <ul className="list-disc list-inside space-y-1 text-black">
                {event.highlights.map((highlight, idx) => (
                  <li key={idx}>{highlight}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Registration Button */}
          {event.registrationUrl && (
            <div className="pt-4">
              <a
                href={event.registrationUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#800000] text-white font-bold py-3 px-8 rounded-full hover:bg-[#9b0000] transition"
              >
                RESERVE YOUR SPOT
              </a>
              <p className="text-sm text-gray-600 mt-3">
                Please mark your calendar and be part of this memorable night!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
